/* ÜRETİLMİŞ DOSYA — ELLE DÜZENLEMEYİN.
   Kaynak: ris-api/RIS.UI/src/shared/template-builder
   Güncelleme: ris-api/scripts/sync-template-builder.sh */

import { Collapse, Empty, Input, Tag, Tooltip } from 'antd'
import { useMemo, useState } from 'react'

/**
 * Alan (placeholder) paleti. Katalog host uygulamadan prop olarak gelir; paket hiçbir alan adı bilmez.
 *
 * Tıklanan alan `onInsert(token)` ile aktif editöre gönderilir — kullanıcının {{...}} sözdizimini
 * ezberlemesi gerekmez.
 */
export default function PlaceholderPalette({ placeholders = [], onInsert, t = (x) => x }) {
    const [search, setSearch] = useState('')

    const groups = useMemo(() => {
        const term = search.trim().toLocaleLowerCase('tr')
        const filtered = placeholders.filter((p) => {
            if (!term) return true
            return (
                String(p.label || '').toLocaleLowerCase('tr').includes(term) ||
                String(p.token || '').toLocaleLowerCase('tr').includes(term)
            )
        })

        const map = new Map()
        filtered.forEach((p) => {
            const key = p.group || t('Diğer')
            if (!map.has(key)) map.set(key, [])
            map.get(key).push(p)
        })

        return [...map.entries()]
    }, [placeholders, search, t])

    return (
        <div className="tb-palette">
            <Input.Search
                size="small"
                allowClear
                placeholder={t('Alan ara')}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ marginBottom: 8 }}
            />

            {groups.length === 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('Alan yok')} />}

            <Collapse
                size="small"
                defaultActiveKey={groups.map(([name]) => name)}
                items={groups.map(([name, items]) => ({
                    key: name,
                    label: `${name} (${items.length})`,
                    children: (
                        <div className="tb-palette-items">
                            {items.map((p) => (
                                <Tooltip
                                    key={p.token}
                                    title={
                                        <>
                                            <div><code>{p.token}</code></div>
                                            {p.sample ? <div>{t('Örnek')}: {p.sample}</div> : null}
                                            {p.note ? <div>{p.note}</div> : null}
                                        </>
                                    }
                                >
                                    <Tag
                                        className="tb-palette-tag"
                                        color={p.kind === 'Image' ? 'purple' : p.kind === 'Table' ? 'gold' : p.kind === 'Html' ? 'blue' : 'default'}
                                        onClick={() => onInsert && onInsert(p.token)}
                                    >
                                        {p.label || p.token}
                                    </Tag>
                                </Tooltip>
                            ))}
                        </div>
                    ),
                }))}
            />
        </div>
    )
}